// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-list-wrapper-info {
  display: inline-block;
  width: 100%;
  padding: 0px 16px 5px 16px;
}
.table-list-wrapper-info .table-list-info-content {
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex-direction: column;
  border-radius: 4px;
  cursor: pointer;
}
.table-list-wrapper-info .table-list-info-content h1 {
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}
.table-list-wrapper-info .table-list-info-content p {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-top: 3px;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  width: 100%;
  min-height: 60px;
  border-bottom: 1px solid var(--sdk-gloabl-border-color);
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card:last-child {
  border-bottom: 0;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .img-block {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .img-block.small-img {
  height: 32px;
  width: 32px;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .img-block.medium-img {
  height: 40px;
  width: 40px;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .img-block figure {
  width: 100%;
  height: 100%;
  line-height: normal;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .img-block figure img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .content-details {
  width: 100%;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .content-details h1 {
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .content-details h1.under-line {
  text-decoration: underline;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .content-details p {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-top: 3px;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .price-tag {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  flex-shrink: 0;
}
.table-list-wrapper-info .table-list-info-content .table-list-data-card .price-tag.under-line {
  text-decoration: underline;
}
.table-list-wrapper-info .show-more-btn {
  padding: 8px;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/tableList/tableList.scss"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,WAAA;EACA,0BAAA;AADJ;AAEI;EACI,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAAR;AACQ;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;AAAZ;AAEQ;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AADZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,uDAAA;AADZ;AAEY;EACI,gBAAA;AAAhB;AAEY;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAAhB;AACgB;EACI,YAAA;EACA,WAAA;AACpB;AACgB;EACI,YAAA;EACA,WAAA;AACpB;AACgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AACpB;AAAoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAExB;AAEY;EACI,WAAA;AAAhB;AACgB;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;AAApB;AACoB;EACI,0BAAA;AACxB;AAEgB;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AADpB;AAIY;EAEI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHhB;AAIgB;EACI,0BAAA;AAFpB;AAOI;EACI,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AALR","sourcesContent":["\n\n.table-list-wrapper-info{\n    display: inline-block;\n    width: 100%;\n    padding: 0px 16px 5px 16px;\n    .table-list-info-content{\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-global-white-bg);\n        display: flex;\n        align-items: flex-start;\n        align-self: stretch;\n        flex-direction: column;\n        border-radius: 4px;\n        cursor: pointer;\n        h1{\n            // color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 600;\n            line-height: normal;\n        }\n        p{\n            // color: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: normal;\n            margin-top: 3px;\n        }\n        .table-list-data-card{\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 12px;\n            width: 100%;\n            min-height: 60px;\n            border-bottom: 1px solid var(--sdk-gloabl-border-color);\n            &:last-child{\n                border-bottom: 0;\n            }\n            .img-block{\n                width: 56px;\n                height: 56px;\n                flex-shrink: 0;\n                &.small-img{\n                    height: 32px;\n                    width: 32px;\n                }\n                &.medium-img{\n                    height: 40px;\n                    width: 40px;\n                }\n                figure{\n                    width: 100%;\n                    height: 100%;\n                    line-height: normal;\n                    img{\n                        width: 100%;\n                        height: 100%;\n                        border-radius: 4px;\n                        object-fit: cover;\n                    }\n                }\n            }\n            .content-details{\n                width: 100%;\n                h1{\n                    // color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 600;\n                    line-height: normal;\n                    &.under-line {\n                        text-decoration: underline;\n                    }\n                }\n                p{\n                    // color: var(--sdk-gloabl-text-color);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: normal;\n                    margin-top: 3px;\n                }\n            }\n            .price-tag{\n                // color: var(--sdk-gloabl-text-color);\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: 18px;\n                flex-shrink: 0;\n                &.under-line {\n                    text-decoration: underline;\n                }\n            }\n        }\n    }\n    .show-more-btn{\n        padding: 8px;\n        color: var(--sdk-global-theme-color);\n        text-align: center;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        border: 0;\n        background: transparent;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
